export function getDisplayName(profile, fallback = '') {
  if (!profile) return fallback;
  const choice = profile.name_display_choice;
  const useNickname = choice === 'nickname' || choice === 'id';
  const nickname = (profile.nickname || '').trim();
  if (useNickname && nickname) return nickname;
  return (profile.name || '').trim() || fallback;
}

export function getFriendDisplayName(friendNickname, profile, fallback = '') {
  const cleanNickname = (friendNickname || '').trim();
  if (cleanNickname) return cleanNickname;
  return getDisplayName(profile, fallback);
}
